import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { Container } from '../../../../components/PriceOverviewCard/components/VoucherInfo/components/Container.js';
import { DEFAULT_CURRENCY, DEFAULT_LOCALE } from '../../../../components/PriceOverviewCard/models.js';
import { Flex, LabelMedium, LabelSmall, Link, Tag } from '../../../../primitives/index.js';
import { priceFormatter } from '../../../../utils/index.js';
import { PRICE_OVERVIEW_QA_ID, qaId } from '../../../../utils/qaId.js';
export const VoucherInfo = ({
  value,
  displayValue,
  locale = DEFAULT_LOCALE,
  currency = DEFAULT_CURRENCY,
  percentage,
  terms
}) => {
  const {
    t
  } = useTranslation();
  return _jsxs(Container, {
    children: [_jsxs(Flex, {
      direction: "row",
      alignItems: "center",
      justifyContent: "space-between",
      "data-testid": qaId(PRICE_OVERVIEW_QA_ID, 'voucher'),
      children: [_jsx(Tag, {
        children: percentage ? t('priceOverviewCard:voucherBox.cashbackVoucher', {
          percentage
        }) : t('priceOverviewCard:voucherBox.moneyBackVoucher', {
          value
        })
      }), _jsxs(LabelMedium, {
        children: ["- ", priceFormatter(locale, currency).format(displayValue)]
      })]
    }), _jsxs("div", {
      children: [_jsx(LabelSmall, {
        color: "contentSecondary",
        children: t('priceOverviewCard:voucherBox.transfer')
      }), _jsx(Link, {
        href: terms,
        target: "_blank",
        children: t('priceOverviewCard:voucherBox.voucherConditions')
      })]
    })]
  });
};